import React, { useState } from "react";
import { db } from "../lib/instant";
import ProductCard from "../components/ProductCard";
import { Search } from "lucide-react";

export default function Shop({ theme }) {
  const primaryColor = theme?.primaryColor || "#6b2118";
  const accentColor  = theme?.accentColor  || "#c9a84c";
  const [search, setSearch] = useState("");
  const [sort, setSort]     = useState("default");

  const { data, isLoading } = db.useQuery({ products: { $: { where: { active: true } } } });
  let products = data?.products || [];

  if (search) products = products.filter(p =>
    (p.name || "").toLowerCase().includes(search.toLowerCase()) ||
    (p.shortDesc || "").toLowerCase().includes(search.toLowerCase())
  );
  if (sort === "price-asc")  products = [...products].sort((a, b) => a.price - b.price);
  if (sort === "price-desc") products = [...products].sort((a, b) => b.price - a.price);

  return (
    <div style={{ paddingTop: 64, minHeight: "100vh", background: "#fdf6e3" }}>

      <div style={{ background: primaryColor, padding: "32px 5vw 28px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div style={{ fontSize: "0.68rem", letterSpacing: 4, textTransform: "uppercase", color: accentColor, fontWeight: 700, marginBottom: 6 }}>Our Store</div>
          <h1 style={{ fontFamily: "Georgia, serif", fontSize: "clamp(1.6rem, 3vw, 2.4rem)", color: "#fff" }}>Shop All Products</h1>
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 5vw 48px" }}>

        <div style={{ display: "flex", gap: 10, marginBottom: 24, alignItems: "center", flexWrap: "wrap" }}>
          {/* Search */}
          <div style={{ position: "relative", flex: "0 0 240px" }}>
            <Search size={13} style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#bbb", pointerEvents: "none" }} />
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search products..."
              style={{
                width: "100%", padding: "7px 10px 7px 30px",
                border: "1.5px solid #ddd", borderRadius: 8,
                fontSize: "0.8rem", outline: "none", background: "#fff",
                color: "#333", boxSizing: "border-box",
              }}
            />
          </div>

          {/* Sort */}
          <select value={sort} onChange={e => setSort(e.target.value)} style={{
            flex: "0 0 auto",
            padding: "7px 12px", border: "1.5px solid #ddd", borderRadius: 8,
            fontSize: "0.8rem", outline: "none", background: "#fff",
            color: "#333", cursor: "pointer", width: "auto",
          }}>
            <option value="default">Sort: Default</option>
            <option value="price-asc">Price: Low to High</option>
            <option value="price-desc">Price: High to Low</option>
          </select>

          {/* Count */}
          <span style={{ fontSize: "0.75rem", color: "#aaa" }}>
            {products.length} product{products.length !== 1 ? "s" : ""}
          </span>
        </div>

        {isLoading ? (
          <div style={{ textAlign: "center", padding: "80px 0", color: "#bbb" }}>
            <div style={{ fontSize: "2rem", marginBottom: 12 }}>⏳</div>
            <p>Loading products...</p>
          </div>
        ) : products.length === 0 && !search ? (
          <div style={{ textAlign: "center", padding: "100px 0" }}>
            <div style={{ fontSize: "4rem", marginBottom: 16 }}>🌾</div>
            <h2 style={{ fontFamily: "Georgia, serif", color: "#2c1810", marginBottom: 8 }}>Products Coming Soon</h2>
            <p style={{ color: "#aaa", fontSize: "0.9rem" }}>Add products from the Admin Panel.</p>
          </div>
        ) : products.length === 0 ? (
          <div style={{ textAlign: "center", padding: "80px 0", color: "#aaa" }}>
            <div style={{ fontSize: "3rem", marginBottom: 12 }}>🔍</div>
            <p>No products match "<strong style={{ color: "#555" }}>{search}</strong>".</p>
            <button onClick={() => setSearch("")} style={{ marginTop: 14, background: "none", border: "1px solid #aaa", color: "#555", padding: "7px 18px", borderRadius: 20, cursor: "pointer", fontSize: "0.82rem" }}>Clear search</button>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 20 }}>
            {products.map(p => <ProductCard key={p.id} product={p} theme={theme} />)}
          </div>
        )}
      </div>
    </div>
  );
}
